import { useAppSelectorV1 } from "@redux/hooks";
import { NavPoint } from "@redux/navPoint/NavPoint";
import { selectPopulatedNavPoint } from "@redux/selectors/getters";
import { isEqual } from "lodash";

export default function useNavPoint(): NavPoint {
  return useAppSelectorV1(selectPopulatedNavPoint, isEqual);
}
